import React, { useState } from 'react';

import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';

import Logo from '../components/Logo';
import HomeIcon from '../components/HomeIcon';
import InsertEmoticonIcon from '@material-ui/icons/InsertEmoticon';
import LocalFloristIcon from '@material-ui/icons/LocalFlorist';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      '& > svg': {
        margin: theme.spacing(2),
      },
    },
    offset: theme.mixins.toolbar,
    menuButton: {
      marginRight: theme.spacing(2),
    },
    menu: {
      width: 250,
    },
  })
);

interface MenuItem {
  title: string;
  icon: JSX.Element;
  to: string;
}

const menuItems0: MenuItem[] = [
  {
    title: 'ホーム',
    icon: <HomeIcon />,
    to: '/#top',
  },
  {
    title: '太陽光発電の設置',
    icon: <InsertEmoticonIcon />,
    to: '/#solar',
  },
];

const menuItems1: MenuItem[] = [
  {
    title: '会社概要',
    icon: <LocalFloristIcon />,
    to: '/about',
  },
];

const createMenuItem = (menuItem: MenuItem) => (
  <ListItem button key={menuItem.title} component="a" href={menuItem.to}>
    <ListItemIcon>{menuItem.icon}</ListItemIcon>
    <ListItemText primary={menuItem.title} />
  </ListItem>
);

function Header() {
  const [isSideMenuOpened, setIsSideMenuOpened] = useState(false);
  const classes = useStyles();

  const sideMenu = (
    <div
      className={classes.menu}
      role="presentation"
      onClick={() => setIsSideMenuOpened(false)}
    >
      <List>{menuItems0.map(createMenuItem)}</List>
      <Divider />
      <List>{menuItems1.map(createMenuItem)}</List>
    </div>
  );

  return (
    <React.Fragment>
      <AppBar position="fixed">
        <Toolbar>
          <div style={{ marginRight: 'auto' }}>
            <Logo />
          </div>
          <IconButton
            edge="end"
            className={classes.menuButton}
            color="inherit"
            aria-label="menu"
            onClick={() => setIsSideMenuOpened(true)}
          >
            <MenuIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      <Drawer
        anchor="right"
        open={isSideMenuOpened}
        onClose={() => setIsSideMenuOpened(false)}
      >
        {sideMenu}
      </Drawer>
      <div className={classes.offset} id="top" />
    </React.Fragment>
  );
}

export default Header;
